import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TimeagoModule} from 'ngx-timeago';
import {AcListItemComponent} from './ac-list-item.component';


@NgModule({
    declarations: [AcListItemComponent],
    imports: [
        CommonModule,
        TimeagoModule,
    ],
    exports: [AcListItemComponent]
})
export class AcListItemModule {
}
